import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_32d2mbpi: FaireBrandEntity = {
  token: "b_32d2mbpi",
  type: "brand",
  name: "Misc Goods Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/3c0460ae50e13e06bde3da8a32a8f3911091b0efebc9134a9c1c90ea1e530627.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8cd5178778a28e33f2c2c2083b2418b9657e866522c5cd5b778e3c5bde896930.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3c0460ae50e13e06bde3da8a32a8f3911091b0efebc9134a9c1c90ea1e530627.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8cd5178778a28e33f2c2c2083b2418b9657e866522c5cd5b778e3c5bde896930.jpeg",
  location: "Louisville, KY, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 44,
  isTopShop: true,
  isInsider: true,
  description:
    "Good work is undeniable — it's known by the value it brings and the character it has. We want to be good at what we do, good to others and good in general for goodness sake. \n\nMisc. Goods Co builds products with practical purpose — keepsakes which are set apart. Manufactured in America, our goods are timeless in form and use, both for home and abroad.\n\nMy company was born out of difficult time. I wasn’t planning or even dreaming of running a product company. Misc. Goods wasn't sparked from a conversation among friends. It emerged from a dry-spell as a free-lance designer and took shape as I allowed my work to bend and shift; changing as opportunity came and working hard when it did. This opportunity for me came in the form of a monstrously successful Kickstarter campaign for a re-designed deck of playing cards. It changed my life and handed me a new set of responsibilities – to create useful, good products – to serve our customers and to remain ethical in all manufacturing. To push forward – ever-content, but never comfortable, to make Misc. Goods Co. a business I can be proud of.\n\nOwner, Designer\n— Tyler Deeb",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:56.386Z",
    importedBy: "entity-db-cli",
  },
};
